import axios from "axios";

const api = axios.create({
  baseURL: "https://api-lgpd.mpt.mp.br/lgpd",
//baseURL: "http://localhost:3040/lgpd",
// baseURL: "http://10.19.0.90:3040/lgpd"
});

export default api




// WEBPACK FOOTER //
// ./src/api.js